// Media queries

const xs = 1000;
let vh = window.innerHeight * 0.01;

const ham = document.getElementById("hamburger");
const hamSticky = document.getElementById("hamburger-sticky");
const togglingMenu = document.getElementById("toggling-menu");
const endTogglingMenu = document.getElementById("end-toggling-menu");
const mobileDivs = document.getElementsByClassName("hideMobile") || [];

if (window.screen.width < xs) {
  ham.classList.remove("hide");
  // togglingMenu.classList.remove("hide");
}

if (window.screen.width < xs) {
  hamSticky.classList.remove("hide");
  // togglingMenu.classList.remove("hide");
}

if (window.screen.width >= xs) {

  if (mobileDivs.length > 0 && !mobileDivs[0].classList.contains("hide")) {
    for (let mobile of mobileDivs) {
      mobile.classList.add("hide");
    }
  }
}

window.addEventListener('resize', () => {

  vh = window.innerHeight * 0.01;

  if (window.screen.width < xs && ham.classList.contains("hide")) {
    ham.classList.remove("hide");
  }
  if (window.screen.width >= xs && !ham.classList.contains("hide")) {
    ham.classList.add("hide");
    togglingMenu.classList.add("hide");
  }
  if (window.screen.width < xs && hamSticky.classList.contains("hide")) {
    hamSticky.classList.remove("hide");
  }
  if (window.screen.width >= xs && !hamSticky.classList.contains("hide")) {
    hamSticky.classList.add("hide");
    togglingMenu.classList.add("hide");
  }
  // if (!document.getElementById("sticky-header").classList.contains("hide") && window.screen.width < 480) {
  //   document.getElementById("sticky-header").classList.add("hide");
  // }
  if (mobileDivs.length > 0 && window.screen.width < xs && mobileDivs[0].classList.contains("hide")) {
    for (let mobile of mobileDivs) {
      mobile.classList.remove("hide");
    }
  }
  if (mobileDivs.length > 0 && window.screen.width >= xs && !mobileDivs[0].classList.contains("hide")) {
    for (let mobile of mobileDivs) {
      mobile.classList.add("hide");
    }
  }
  if (mobileDivs.length > 0 && window.screen.width >= xs && !mobileDivs[0].classList.contains("hide")) {
    for (let mobile of mobileDivs) {
      mobile.classList.add("hide");
    }
  }

})

ham.addEventListener('click', () => {
  togglingMenu.classList.remove("hide");
})

hamSticky.addEventListener('click', () => {
  togglingMenu.classList.remove("hide");
})

endTogglingMenu.addEventListener('click', () => {
  togglingMenu.classList.add("hide");
})

for (let mobile of mobileDivs) {
  if (window.screen.width < xs) {
    mobile.classList.remove("hide");
  }
}


///////////

let lastScrollTop = window.scrollY;

const contactBtns = document.getElementsByClassName("bouton-me-contacter");
const contactBox = document.getElementById("contact");

for (let value of contactBtns) {
  value.addEventListener('click', () => {
    if (value.classList.contains("clicked")) {
      value.innerHTML = `Me contacter`;
      value.classList.remove("clicked");
      contactBox.classList.add("hide");
    }
    else {
      value.innerHTML = `<i class="fa-solid fa-xmark fa-lg"></i>`;
      value.classList.add("clicked");
      contactBox.classList.remove("hide");
    }
  })
}

document.addEventListener('scroll', event => {
  let st = window.scrollY || document.documentElement.scrollTop; 
   if (st > lastScrollTop && window.scrollY >= 709 && document.getElementById("sticky-header").classList.contains("hide") ){
      document.getElementById("sticky-header").classList.remove("hide");
   } else if (st < lastScrollTop & window.pageYOffset <= 709 && !document.getElementById("sticky-header").classList.contains("hide")) {
    document.getElementById("sticky-header").classList.add("hide");
   }
   lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
   for (let value of contactBtns) {
    value.innerHTML = `Me contacter`;
    value.classList.remove("clicked");
    contactBox.classList.add("hide");
   }
})

// View height probleme resolved

document.documentElement.style.setProperty('--vh', `${vh}px`);